import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ValueProposition from "@/components/ValueProposition";
import Products from "@/components/Products";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import BrandStory from "@/components/BrandStory";
import B2B from "@/components/B2B";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import BodysPage from "@/pages/BodysPage";
import BodyDetailPage from "@/pages/BodyDetailPage";
import TiendaPage from "@/pages/TiendaPage";
import ScrollToTop from "@/components/ScrollToTop";
import { ThemeProvider } from "@/contexts/ThemeContext";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-page text-ink">
      <Navbar />
      <Hero />
      <ValueProposition />
      <Products />
      <HowItWorks />
      <Testimonials />
      <BrandStory />
      <B2B />
      <FinalCTA />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
};

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tienda" element={<TiendaPage />} />
            <Route path="/bodys" element={<BodysPage />} />
            <Route path="/bodys/:slug" element={<BodyDetailPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
